import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ViventiaLogo } from './-components/orgs/assets/client-viventia'
import { LanguageSelector } from './-components/language-selector'
import { CenteredSpinnerPending } from './-components/app-layout-skeleton'

export const Route = createFileRoute('/_app/orgs_/$orgId/users/groups')({
  component: RouteComponent,
  pendingComponent: CenteredSpinnerPending,
})

function RouteComponent() {
  return (
    <div className="flex flex-col items-center gap-10">
      <ViventiaLogo className="mx-auto h-28 w-full" />
      <Outlet />

      <div className="fixed top-0 right-0 m-6">
        <LanguageSelector />
      </div>
    </div>
  )
}
